import PropTypes from 'prop-types'

// Internal components
import Svg from '../Svg/Svg'

const Caption = ({ html, iconId, modifiers }) => {
  const createMarkup = (copy) => ({ __html: copy && typeof copy === 'object' ? copy.html : copy })
  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''

  return (
    <div className={`Caption${modifierClasses}`}>
      {iconId && <Svg id={iconId} modifiers={['Caption-icon']} />}
      <span dangerouslySetInnerHTML={createMarkup(html)}></span>
    </div>
  )
}

Caption.propTypes = {
  html: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  iconId: PropTypes.string,
  modifiers: PropTypes.array
}

export default Caption
